/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyRepresentation } from './CompanyRepresentation';
import {
    CompanyRepresentationFromJSON,
    CompanyRepresentationFromJSONTyped,
    CompanyRepresentationToJSON,
    CompanyRepresentationToJSONTyped,
} from './CompanyRepresentation';
import type { UserRepresentation } from './UserRepresentation';
import {
    UserRepresentationFromJSON,
    UserRepresentationFromJSONTyped,
    UserRepresentationToJSON,
    UserRepresentationToJSONTyped,
} from './UserRepresentation';

/**
 * 
 * @export
 * @interface TokenRepresentation
 */
export interface TokenRepresentation {
    /**
     * 
     * @type {string}
     * @memberof TokenRepresentation
     */
    token?: string;
    /**
     * 
     * @type {UserRepresentation}
     * @memberof TokenRepresentation
     */
    user?: UserRepresentation;
    /**
     * 
     * @type {CompanyRepresentation}
     * @memberof TokenRepresentation
     */
    company?: CompanyRepresentation;
    /**
     * 
     * @type {Array<string>}
     * @memberof TokenRepresentation
     */
    roles?: Array<string>;
}

/**
 * Check if a given object implements the TokenRepresentation interface.
 */
export function instanceOfTokenRepresentation(value: object): value is TokenRepresentation {
    return true;
}

export function TokenRepresentationFromJSON(json: any): TokenRepresentation {
    return TokenRepresentationFromJSONTyped(json, false);
}

export function TokenRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
        'user': json['user'] == null ? undefined : UserRepresentationFromJSON(json['user']),
        'company': json['company'] == null ? undefined : CompanyRepresentationFromJSON(json['company']),
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function TokenRepresentationToJSON(json: any): TokenRepresentation {
    return TokenRepresentationToJSONTyped(json, false);
}

export function TokenRepresentationToJSONTyped(value?: TokenRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'user': UserRepresentationToJSON(value['user']),
        'company': CompanyRepresentationToJSON(value['company']),
        'roles': value['roles'],
    };
}

